import React, { useContext, useEffect, useState } from "react";
import HyperLogo from "../../Images/HyperLogo.png";
import styled from "styled-components";
import Select from "react-select";
import Clock from "./Clock";
import Player from "./Player";
import Subs from "../Subs/Subs";
import EndHalf from "./EndHalf";
import moment from "moment";
import { Button, ScrollBar } from "../../Theme/Hyper";
import { UserContext } from "../../contexts/UserContext";
import { APIContext } from "../../contexts/APIContext";
import  SelectUI  from "../UI/Form/SelectUI";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { usePullFightPrediction } from "../../FanPrediction/FanPredictionCall";

const SelectContainer = styled(Select)`
  min-width: 160px;
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  width: 90%;
`;

const Main = styled.div`
  display: flex;

  align-items: center;
  width: 100%;
  padding-top: 0.5em;
  background-color: #202731;
  box-sizing: border-box;
  flex-direction: column;
  position: relative;
`;


const Logo = styled.img`
  height: auto;
  width: 50%;
`;
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 40px;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const CurrentGraphic = styled.div`
  margin-top: auto;
  width: 100%;
  height: 167px;
  background-color: #181d25;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 12px;
  margin: 0px;
  padding-bottom: 10px;
`;
const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const NavButton = styled(Button)`
  margin: 0.3em;
  margin-top: 0.5em;
  background-color: ${(props) => (props.selected ? "#0adb93" : "")};
  color: ${(props) => (props.selected ? "#1d1d1d" : "")};
`;

const Profile = styled.div`
  width: 100%;
  height: 35px;
  background-color: #202731;
  z-index: 1000;
  position: -webkit-sticky;
  position: sticky;
  box-shadow: 0px 4px 12px -20px rgb(0 0 0 / 20%),
    0px 8px 20px 2px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%);
  display: flex;
  align-items: center;
  border-bottom: 1px solid #030304;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
  padding-bottom: 5px;
  margin-bottom: 10px;
`;

const GraphicsList = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  max-height: 560px;
  overflow-y: auto;
  width: 100%;
  align-items: center;
`;

const DropdownStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: "rgb(34, 36, 43)",
      "&:hover": {
        color: "#db0a41",
      },
    };
  },
  control: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
    borderColor: "#384454",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
    borderColor: "#384454",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition, color: "#fff" };
  },
};


const DECISIONS = [
  {value: " ", label: "CLEAR"},
  {value: "KO", label: "KO"},
  {value: "TKO", label: "TKO"},
  {value: "Unanimous Decision", label: "Unanimous Decision"},
  {value: "Split Decision", label: "Split Decision"},
  {value: "Submission", label: "Submission"},
  {value: "Decision", label: "Decision"},
  {value: "Disqualification", label: "Disqualification"},
];
export default function RightSideBar({
  game,
  updateGame,
  previewGraphic,
  graphicInPreview,
  animateGraphic,
  animateOffGraphic,
  updateGraphic,
  teams,
  selectedPlayer,
  players,
  stadiums,
  sky,
  squads,
  countries,
  standings,
  kits,
  clearPreview,
  homeManager,
  awayManager,
  gamesByDate,
}) {
  const pullFightPrediction = usePullFightPrediction();
  const [GameSave, setGameSave] = useLocalStorage("hyper-combat-fightcard");
  useEffect(() => {
    if (gamesByDate && gamesByDate.length > 0) {
      setGameSave({
        ...GameSave,
        cachedGames: gamesByDate
      });
    }
  }, [gamesByDate]);
  const activeGames = gamesByDate || GameSave.cachedGames || [];
  const { user, signOut } = useContext(UserContext);
  const [view, setView] = useState(0);
  const [decision, setDecision] = useState("");
  const {updateWinner, updatePrediction} = useContext(APIContext);
  let period = [...(game?.live_data?.periods || [])].sort(
    (a, b) => b.number - a.number
  )[0];

  let latestGoal =
    game && game.live_data?.home_scorers ? game.live_data?.home_scorers : [];

  latestGoal = latestGoal
    .concat(game.live_data?.away_scorers || [])
    .sort((a, b) => b.time - a.time);
  if (latestGoal.length > 0) {
    latestGoal = latestGoal[0].time;
  }
  let time = moment.duration(latestGoal);
  time =
    time.minutes() +
    time.hours() * 60 +
    ":" +
    time.seconds().toString().padStart(2, "0");

  return (
    <Main>
      {!window.hideHeader && (
        <Profile>
          {user?.username}
          <Button
            style={{ border: "1px solid #fff", marginLeft: "auto" }}
            onClick={() => {
              signOut();
            }}
          >
            Sign Out
          </Button>
        </Profile>
      )}
      <Logo src={HyperLogo}></Logo>
      <Clock
        game={game}
        teams={teams}
        updateGame={updateGame}
        previewGraphic={previewGraphic}
        animateGraphic={animateGraphic}
        animateOffGraphic={animateOffGraphic}
        updateGraphic={updateGraphic}
        sky={sky}
      />
      <Buttons>
        <NavButton selected={view === 0} onClick={() => setView(0)}>
          PRE-FIGHT
        </NavButton>
        <NavButton selected={view === 1} onClick={() => setView(1)}>
          IN-FIGHT
        </NavButton>
        <NavButton selected={view === 2} onClick={() => setView(2)}>
          POST FIGHT
        </NavButton>
      </Buttons>
      {view === 0 && (
      <GraphicsList>
      <GraphicButton
        onClick={() => {
          previewGraphic("Fight Ident FF", {
            game: game,
          });
        }}
      >
        FF Title Card
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("Walkout L3RD", {
            game: game,
            player: game?.home_fighter,
            corner: "0",
          });
        }}
      >
        Red Walkout L3RD
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("Walkout L3RD", {
            game: game,
            player: game?.away_fighter,
            corner: "1",
          });
        }}
      >
        Blue Walkout L3RD
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("Tale of the Tape", {
            game: game,
            fanvoteomo: 1,
          });
        }}
      >
       Tale of the Tape - No Fan Vote
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("Tale of the Tape", {
            game: game,
            fanvoteomo: 2,
          });
        }}
      >
       Tale of the Tape - Fan Vote
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("MCName", {
            game: game,
          });
        }}
      >
        MC Name
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("Ring L3RD", {
            game: game,
            player: game?.home_fighter,
            corner: "0",
          });
        }}
      >
        Red In-Ring L3RD
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("Ring L3RD", {
            game: game,
            player: game?.away_fighter,
            corner: "1",
          });
        }}
      >
        Blue In-Ring L3RD
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("RefereeName", {
            game: game,
          });
        }}
      >
        Referee Name
      </GraphicButton>
      </GraphicsList>
      )}
      {view === 1 && (
        <GraphicsList>
      <GraphicButton
        onClick={() => {
          previewGraphic("FFStats", {
            game: game,
            type: "HT",
            half: 1,
          });
        }}
      >
        FF Stats
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("L3Stats", {
            game: game,
          });
        }}
      >
        L3 Stats
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("L3StatsALT", {
            game: game,
            player: game?.home_fighter,
            stats: game?.home_player_stats,
            corner: "1",
          });
        }}
      >
        L3 Stats ALT BLUE
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("L3StatsALT", {
            game: game,
            player: game?.away_fighter,
            stats: game?.away_player_stats,
            corner: "0",
          });
        }}
      >
        L3 Stats ALT RED
      </GraphicButton>
        </GraphicsList>
      )}
      {view === 2 && (
        <>
          Winner: {game?.winner?.first_name + " " + game?.winner?.last_name}
          <Buttons
          style={{marginBottom: "0.5em"}}>
          <NavButton onClick={() => {
            let newWinner = game?.winner;
           newWinner = game?.home_fighter;
           let gamestate = game?.completed;
           gamestate = 1;            
           updateWinner({id: game._id, winner: newWinner, completed: gamestate});
      }}>{game?.home_fighter?.first_name + " " + game?.home_fighter?.last_name}</NavButton>
          <NavButton onClick={() => {
            let newWinner = game?.winner;
           newWinner = game?.away_fighter;
           let gamestate = game?.completed;
           gamestate = 2;
           updateWinner({id: game._id, winner: newWinner, completed: gamestate});
      }}>{game?.away_fighter.first_name + " " + game?.away_fighter?.last_name}</NavButton>
                <NavButton onClick={() => {
            let newWinner = game?.winner;
           newWinner = "";
           let gamestate = 0;

           updateWinner({id: game._id, winner: newWinner, completed: gamestate, winnerby: " "});
      }}> RESET </NavButton>
          </Buttons>
          <SelectContainer
          styles={DropdownStyles}
          setSize={true}
          value={DECISIONS.find(
            (option) => option.value === (game?.winnerby || " "),
          )}
          options={DECISIONS}
          onChange={(e) => {
            updateWinner({...game, id: game._id,  winnerby: e.value });
          }}
          placeholder="Select Winning Method"/>
          <GraphicsList>
        <GraphicButton
        onClick={() => {
          previewGraphic("WinnerL3rd", {
            game: game,
          });
        }}
      >
        Winner L3rd
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          previewGraphic("FFStats", {
            game: game,
            type: "HT",
            half: 1,
          });
        }}
      >
        Post Fight Stats
      </GraphicButton>
      </GraphicsList>
      </>
      )}
      {graphicInPreview && (
        <CurrentGraphic
          style={{ bottom: window.hideHeader === true ? "130px" : "40px" }}
        >
          {graphicInPreview.name}
          <GraphicButton
            style={{ height: "40px", backgroundColor: "#383f4a" }}
            onClick={() => {
              clearPreview(graphicInPreview.name);
            }}
          >
            CLEAR PVW (CTRL + Q)
          </GraphicButton>

          <GraphicButton
            green
            style={{ height: "40px" }}
            onClick={() => {
              animateGraphic(graphicInPreview.name);
            }}
          >
            IN (F8) or (-)
          </GraphicButton>
          <GraphicButton
            red
            style={{ height: "40px" }}
            onClick={() => {
              animateOffGraphic(graphicInPreview.name);
            }}
          >
            OUT (F9) or (*)
          </GraphicButton>
        </CurrentGraphic>
      )}
    </Main>
  );
}
